import { SearchHistoryService } from '@weave/schema-gen-ts/dist/schemas/search/history/v1/search.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSearchHistory = bindHTTP(SearchHistoryService);
